import { createAction, props } from '@ngrx/store';
import { SortDir } from '@shared';
import { ApiKey } from '@shared/models/api-management/api-key';
import { Pagination } from '@shared/pagination';
import { ScopeGroup } from '@shared/models/api-management/scope-group';

export const loadApiKeys = createAction(
  '[Api management] load api keys',
  (
    payload: { offset?: number; sortOn: string; sortDir: SortDir } = {
      offset: 0,
      sortOn: 'name',
      sortDir: SortDir.DESC,
    },
  ) => payload,
);

export const loadApiKeysSuccess = createAction(
  '[Api management] load api keys success',
  props<{ apiKeysPage: Pagination<ApiKey> }>(),
);

export const loadApiKeysFail = createAction(
  '[Api management] load api keys fail',
  props<{ error }>(),
);

export const createApiKey = createAction(
  '[Api management] create api key',
  props<{ apiKey: Partial<ApiKey> }>(),
);

export const createApiKeySuccess = createAction(
  '[Api management] create api key success',
  props<{ apiKeySecret: string }>(),
);

export const createApiKeyFail = createAction(
  '[Api management] create api key fail',
  props<{ error }>(),
);

export const updateApiKey = createAction(
  '[Api management] update api key',
  props<{ apiKey: ApiKey }>(),
);

export const updateApiKeySuccess = createAction(
  '[Api management] update api key success',
  props<{ apiKey: ApiKey }>(),
);

export const updateApiKeyFail = createAction(
  '[Api management] update api key fail',
  props<{ error }>(),
);

export const revokeApiKey = createAction(
  '[Api management] revoke api key',
  props<{ apiKeyId: string }>(),
);

export const revokeApiKeySuccess = createAction(
  '[Api management] revoke api key success',
  props<{ apiKey: ApiKey }>(),
);

export const revokeApiKeyFail = createAction(
  '[Api management] revoke api key fail',
  props<{ error }>(),
);

export const activateApiKey = createAction(
  '[Api management] activate api key',
  props<{ apiKeyId: string }>(),
);

export const activateApiKeySuccess = createAction(
  '[Api management] activate api key success',
  props<{ apiKey: ApiKey }>(),
);

export const activateApiKeyFail = createAction(
  '[Api management] activate api key fail',
  props<{ error }>(),
);

export const loadScopeGroups = createAction('[Api management] load scope groups');

export const loadScopeGroupsSuccess = createAction(
  '[Api management] load scope groups success',
  props<{ scopeGroups: ScopeGroup[] }>(),
);

export const loadScopeGroupsFail = createAction(
  '[Api management] load scope groups fail',
  props<{ error }>(),
);
